var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackgroundIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 6.219a8 8 0 0 1 8 8v12a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8v-12a8 8 0 0 1 8-8h24zm0 3H8a5 5 0 0 0-4.995 4.783L3 14.218v12a5 5 0 0 0 4.783 4.996l.217.005h24a5 5 0 0 0 4.995-4.784L37 26.22v-12a5 5 0 0 0-4.783-4.996L32 9.22zM9.293 24.106l5.993-8.57c1.196-1.712 3.708-1.762 4.972-.112l.085.116 2.439 3.502.012-.013a3.09 3.09 0 0 1 4.458.2l.127.155.071.097 3.254 4.62c.516.734.34 1.748-.393 2.264-.684.482-1.618.365-2.195-.302l-.07-.09-3.118-4.428-.176.25c-.916 1.294-2.781 1.384-3.838.217l-.114-.135-.072-.098-2.916-4.186-5.855 8.375a1.625 1.625 0 0 1-2.13.484l-.133-.083c-.685-.48-.893-1.398-.463-2.167l.062-.096z",
    fill: "#6238F9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundIcon);
export default __webpack_public_path__ + "static/media/background-icon.c4e405c47fd7a244f4efd158de3e1a24.svg";
export { ForwardRef as ReactComponent };